import { SoundConfig } from "../../../SoundConfig";
import { ReelSlicedDivider } from "../../independent/divider/ReelSlicedDivider";
import { StateSymbolWin } from "../../independent/symbol/StateSymbolWin";
import { ReelState } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { TimeCheckPoints } from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import { ReelItemOverlay } from "../../independent/overlay/ReelItemOverlay";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { TrainState } from "../../independent/countup/XWaysCounter";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { TweenMax } from "gsap";
import { Presentation } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

class ReelSpinStartState extends StateHandler{
    public static readonly START:string = "start"; 
    public static readonly DONE:string = "done"; 
}

export class ReelStartPresentation extends Presentation {

    protected state:ReelSpinStartState = new ReelSpinStartState(ReelSpinStartState.DONE);

    public isActive():boolean{
        return !PunkEngineManager.isPlaying && this.state.equal(ReelSpinStartState.DONE);
    }

    public getPresentation():void{
        this.normalPresentation();
    }

    protected normalPresentation():void{
        
        PunkGameModuleConfig.xWayCounter.trainActive() ? this.removeTrain() : SoundManager.fadeAmbienceLoop(1,1);
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        this.state.set(ReelSpinStartState.START);
        TimeCheckPoints.setCheckPoint("Bet");
        PunkEngineManager.onBeforeSpinStart();
        this.normalStart();
    }

    protected normalStart():void{
        let featureStart:boolean = false;
        if(!PunkEngineManager.AllReels[PunkEngineManager.AllReels.length-1].getSymbol(0)!.children[0].visible){
            if(PunkEngineManager.AllReels[PunkEngineManager.AllReels.length-1].isActive) featureStart = true;
        }

        for(let i = 0; i < PunkEngineManager.AllReels.length; i++){ if(!PunkEngineManager.AllReels[i].state.isSpinning) PunkEngineManager.AllReels[i].createStart(false); }

        var delay:number = 0;
        var totalDuration:number = 0;
        
        StateSymbolWin.instance.hideItems();
        for(let reel = 0; reel < PunkEngineManager.AllReels.length;reel++){
            this.pTimeline.add(() => PunkEngineManager.AllReels[reel].startReel(),featureStart && reel == 5 ? 0 : delay);
            if(PunkEngineManager.AllReels[reel].isActive){
                this.pTimeline.add(() => StateSymbolWin.instance.fadeOutMult(reel),delay);
                this.pTimeline.add(() => ReelSlicedDivider.instance.fadeOutAndRemove(reel),delay);
            } 
            delay += PunkEngineManager.AllReels[reel].startDelay();
            // Get the longest StartTime to be added on the total delay between reels.
            if(PunkEngineManager.AllReels[reel].getPlayTime() > totalDuration)
                totalDuration = PunkEngineManager.AllReels[reel].getPlayTime();
            else if(totalDuration < PunkEngineManager.AllReels[reel].getNextAnimationTime())  totalDuration = PunkEngineManager.AllReels[reel].getNextAnimationTime();
        }
        
        this.pTimeline.to(this,delay + totalDuration,{});
        SoundManager.playSoundEffect(SoundConfig.instance.REELS_SPIN_START[0]);
        SoundManager.playSoundEffect(SoundConfig.instance.REELS_SPINNING,100000000);
        
        if(this.pTimeline.totalDuration() < PunkGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.SPIN_TIME)
            this.pTimeline.to(this, PunkGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.SPIN_TIME-this.pTimeline.totalDuration(),{});
    }

    protected removeTrain():void{
        
        SoundManager.fadeAmbienceLoop(0.6,1);

        this.pTimeline.add(PunkGameModuleConfig.xWayCounter.showGlowPositions([0,1,2,3,4,5],false,0.3));
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.showTrainItems(false,[], 0.3));
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.OPEN_CLOSE,true),this.pTimeline.totalDuration() + 0.15);
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.OUTRO), this.pTimeline.totalDuration() +  MathHelper.frameToSeconds(10));
        this.pTimeline.to(this, TrainState.getDuration(TrainState.OUTRO),{});
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.FreeSpinsCounter(1.5,true),0.3);//"-=0.5");
    }
    
    public promiseSync():boolean{
        return PunkEngineManager.findFirstReelWithState(ReelState.START) == -1;
    }

    public stopPresentation():void{
        this.state.set(ReelSpinStartState.DONE);
        PunkEngineManager.isPlaying = true;
        StateSymbolWin.instance.cleanItems();
        ReelItemOverlay.instance.reset();
        ReelItemOverlay.instance.reelStopped = false;
    }

    public skipPresentation():void{
        TweenMax.globalTimeScale(3);
        PunkEngineManager.RAll((reelID:number) => PunkEngineManager.getReel(reelID).isQuickStop = true);
    }
}